import { render, staticRenderFns } from "./Mypatient.vue?vue&type=template&id=5f5b7255&scoped=true"
import script from "./Mypatient.vue?vue&type=script&lang=js"
export * from "./Mypatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b7255",
  null
  
)

export default component.exports